// extracted by mini-css-extract-plugin
export default {"cell":"LeftColumnBody_cell__K8XoO","placeHolderShimmer":"LeftColumnBody_placeHolderShimmer__T3WKy"};